import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { END_POINT } from "config/environment";
import { useGetUserInfo } from "hooks/useGetUserInfo";

export interface NotificationPreferences {
  timezone: string;
  interview_reminder_email: boolean;
  job_expiry_reminder_email: boolean;
}

export type NotificationPreferencesUpdate = Partial<NotificationPreferences>;

export const QUERY_KEY_FOR_NOTIFICATION_PREFERENCES = "notification-preferences";
const url = `${END_POINT.BASE_URL}/v1/notification-preferences`;

const headers = (token: string) => ({
  Accept: "application/json",
  Authorization: `Bearer ${token}`,
});

export const useGetNotificationPreferences = () => {
  const { token } = useGetUserInfo();

  return useQuery<NotificationPreferences, Error>(
    [QUERY_KEY_FOR_NOTIFICATION_PREFERENCES],
    async () => {
      const response = await axios.get<{ data: NotificationPreferences }>(url, {
        headers: headers(token),
      });
      return response.data.data;
    },
    { enabled: Boolean(token) }
  );
};

export const useUpdateNotificationPreferences = () => {
  const { token } = useGetUserInfo();
  const queryClient = useQueryClient();

  return useMutation(
    async (payload: NotificationPreferencesUpdate) => {
      const response = await axios.put<{ data: NotificationPreferences }>(
        url,
        payload,
        { headers: headers(token) }
      );
      return response.data.data;
    },
    {
      onSuccess: (data) => {
        queryClient.setQueryData([QUERY_KEY_FOR_NOTIFICATION_PREFERENCES], data);
      },
    }
  );
};
